import { useQuery } from '@tanstack/react-query';

import { videoCallService, type CallStatusResponse } from '../services';

import { videoKeys } from './videoKeys';

/**
 * Query hook for GET /sessions/:id/call/status. One-shot fetch by
 * default (staleTime: Infinity) — pre-join's Refresh button calls
 * refetch manually. Not used for continuous polling; LiveKit's own
 * event stream handles live state once connected.
 */
export function useCallStatus(sessionId: string) {
  return useQuery<CallStatusResponse>({
    queryKey: videoKeys.callStatus(sessionId),
    queryFn: () => videoCallService.getCallStatus(sessionId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
